import React, { Component } from 'react';
import { connect } from 'react-redux';
import { breadcrumbs } from '../../../../actions/appActions';
import { push } from 'react-router-redux';
import { isInternal } from '../../CroUtils';
import OvmGrid from '../../components/grids/OvmGrid';
import ShowOverviewHistoryButton from '../../components/audit/ShowOverviewHistoryButton';

class Ovms extends Component {
  componentWillMount() {
    this.props.breadcrumbs([{ label: 'Podpůrné orgány' }]);
  }

  onEdit = ({ id }) => {
    this.props.push(`${this.props.auth.startUrl}/podpurne-organy/form/${id}`);
  }

  onAdd = () => {
    this.props.push(`${this.props.auth.startUrl}/podpurne-organy/form`);
  }

  render() {
    const { auth } = this.props;

    return (
      <div>
        <ShowOverviewHistoryButton auth={auth} segment="podpurne-organy" />
        <OvmGrid
          gridName='ovmGrid_all'
          url={`${auth.startUrl}/api/podpurne-organy`}
          adding={isInternal(auth)}
          onAdd={this.onAdd}
          onRowClick={this.onEdit} />
      </div>
    );
  }
}

export default connect(null, { breadcrumbs, push })(Ovms);
